import { JSX } from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { SxProps, Theme } from '@mui/material';

interface Props {
  label: string;
  sx?: SxProps<Theme>;
}

export default function SectionLabel({ label, sx }: Props): JSX.Element {
  const theme = useTheme();
  return (
    <Typography
      sx={{
        textTransform: 'uppercase',
        fontSize: 11,
        fontWeight: 700,
        color: theme.palette.mode === 'dark' ? 'primary.light' : 'primary.main',
        letterSpacing: '1px',
        ...sx,
      }}
    >
      {label}
    </Typography>
  );
}
